import { render, staticRenderFns } from "./SmoSmtHistory.vue?vue&type=template&id=f638ad66&scoped=true"
import script from "./SmoSmtHistory.vue?vue&type=script&lang=js"
export * from "./SmoSmtHistory.vue?vue&type=script&lang=js"
import style0 from "./SmoSmtHistory.vue?vue&type=style&index=0&id=f638ad66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f638ad66",
  null
  
)

export default component.exports